import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`To set a `}<inlineCode parentName="p">{`ReturnShipmentState`}</inlineCode>{`, there needs to be at least one `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#returninfo"
        }}>{`ReturnInfo`}</a>{` with at least one `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#returnitem"
        }}>{`ReturnItem`}</a>{` created before.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setReturnShipmentState"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`returnItemId`}</inlineCode>{` - String - ID of the concerning `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnitem"
          }}>{`ReturnItem`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`shipmentState`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnshipmentstate"
          }}>{`ReturnShipmentState`}</a></li>
      </ul>
      <p parentName="section">{`This update action produces an `}<a parentName="p" {...{
          "href": "/api/../api/message-types#orderreturnshipmentstatechangedmessage"
        }}>{`OrderReturnShipmentStateChangedMessage`}</a>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      